import * as tslib_1 from "tslib";
import * as React from 'react';
import { lazyHideFlexPane, lazyShowFlexPane } from 'owa-flex-pane';
import { observer } from 'mobx-react';
var styles = require('./HeaderPane.scss');
var HeaderFlexPane = /** @class */ (function (_super) {
    tslib_1.__extends(HeaderFlexPane, _super);
    function HeaderFlexPane() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderFlexPane.prototype.componentDidMount = function () {
        var _a = this.props, content = _a.content, title = _a.title, onDismiss = _a.onDismiss;
        lazyShowFlexPane.importAndExecute(React.createElement("div", { className: styles.headerFlexPaneContentDiv }, content), {
            headerText: title,
            onDismiss: onDismiss,
        });
    };
    HeaderFlexPane.prototype.componentWillUnmount = function () {
        lazyHideFlexPane.importAndExecute();
    };
    HeaderFlexPane.prototype.render = function () {
        return null;
    };
    HeaderFlexPane = tslib_1.__decorate([
        observer
    ], HeaderFlexPane);
    return HeaderFlexPane;
}(React.Component));
export default HeaderFlexPane;
//# sourceMappingURL=HeaderFlexPane.js.map